import axios from 'axios';
import ClaimRequestReferralTable, {
  tableColumns
} from 'components/tables/ClaimRequestReferralTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { faKey, faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import CustomerNotesCard from 'components/cards/CustomerNotesCard';
import CustomerProfileCard from './CustomerProfileCard';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import UserWalletTable from 'components/tables/UserWalletTable';
import CustomerRatingsTable from 'components/tables/CustomerRatingsTable';
import CustomerWishlistTable from 'components/tables/CustomerWishlistTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import UserReferralPointsRewardTable, {
  tableColumnsForReferralPointsReward
} from 'components/tables/UserReferralPointsRewardTable';

const UserReferralPointsReward = () => {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [transaction, setTransaction] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    fetchUserReferralPointsRewards();
  }, [id, pagination]);

  const fetchUserReferralPointsRewards = async () => {
    const url = `/referral-points-transactions`;

    let params: Record<string, any> = {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize
    };

    if (id) {
      params = { ...params, userId: id };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: params
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setTransaction(response.data['data']);
    setTotalRecords(response.data['totalRecords']);
  };
  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };
  const table = useAdvanceTable({
    data: transaction,
    columns: tableColumnsForReferralPointsReward,
    pageSize: pagination.pageSize,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      fetchUserReferralPointsRewards: fetchUserReferralPointsRewards
    }
  });
  return (
    <div>
      <h3 className="mb-4">
        Referral Points Reward{' '}
        <span className="text-body-tertiary fw-normal">({totalRecords})</span>
      </h3>
      <AdvanceTableProvider {...table}>
        <UserReferralPointsRewardTable />
      </AdvanceTableProvider>
    </div>
  );
};

export default UserReferralPointsReward;
